import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { SiteModel } from 'src/app/sites-builder/models/site.model';
import { SbApiService } from 'src/app/sites-builder/services/sb-api.service';

@Component({
  selector: 'app-redirect-modal',
  templateUrl: './redirect-modal.component.html',
})
export class RedirectModalComponent implements OnInit {
  public site: SiteModel;
  public redirectUrl: string;
  public closeReason: 'success' | 'cancel';
  public updatedSite: SiteModel;

  constructor(
    private bsModalRef: BsModalRef,
    private sbApiService: SbApiService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.redirectUrl = this.site.redirect_url ?? '';
  }

  public onDismiss(reason: 'success' | 'cancel') {
    this.closeReason = reason;
    this.bsModalRef.hide();
  }

  public onSubmit() {
    const redirectUrl = this.redirectUrl && this.redirectUrl.length > 0 ? this.redirectUrl : null;
    this.sbApiService.updateRedirectUrl(this.site.id, { redirectUrl: redirectUrl }).subscribe({
      next: res => {
        this.updatedSite = res.site;
        this.onDismiss('success');
        this.toastr.success('Site redirect url saved.', 'Redirect Url');
      },
      error: error => {
        console.error(error);
        this.toastr.error('', 'An error has occurred');
      }
    });
  }

}
